import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

export const ModalBox = styled.div`
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
`;

export const ModalTitle = styled.h2`
  margin-bottom: 2rem;
  font-size: 24px;
  font-weight: 700;
`;

export const ModalSubtitle = styled.p`
  margin-top: 2rem;
  font-size: 18px;
  font-weight: 600;
`;

export const ModalLabel = styled.label`
  display: block;
  margin-bottom: 1rem;
  font-weight: 500;
`;

export const ModalInput = styled.input`
  width: 26%;
  padding: 0.5rem;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-top: 0.4rem;

  :disabled {
    background-color: #e5e5e5cc;
    border: 1px solid #e5e5e5cc;
  }
`;

export const ModalValues = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .money-sign {
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 6px;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 1.5rem;
`;

export const ConfirmButton = styled.button`
  padding: 0.6rem 1.2rem;
  font-size: 1.4rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: rgba(136, 48, 152, 1);
  color: white;
  font-weight: 500;
`;

export const CancelButton = styled.button`
  padding: 0.6rem 1.2rem;
  font-size: 1.4rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: rgb(255, 255, 255);
  color: black;
  font-weight: 500;
  border: 1px solid rgb(172, 172, 172);
`;
